import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

interface Country {
	code: string;
	name: string;
}

interface CountrySelectProps {
	value: string;
	onChange: (value: string | null) => void;
	countries: Country[];
	"aria-invalid"?: boolean;
	"data-warning"?: boolean;
}

function CountrySelect({
	value,
	onChange,
	countries,
	"aria-invalid": ariaInvalid,
	"data-warning": dataWarning,
}: CountrySelectProps) {
	return (
		<Select
			value={value}
			onValueChange={onChange}
			items={countries.map((country) => ({
				value: country.code,
				label: country.name,
			}))}
		>
			<SelectTrigger
				className="w-full"
				aria-invalid={ariaInvalid}
				data-warning={dataWarning}
			>
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				{countries.map((country) => (
					<SelectItem key={country.code} value={country.code}>
						{country.name}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}

export { CountrySelect, type Country, type CountrySelectProps };
